module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 6);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("tslib");

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"base":"_0_9_0_text__base___1jep0","preset-displayL":"_0_9_0_text__preset-displayL___1x2Ch","preset-displayS":"_0_9_0_text__preset-displayS___3EscH","preset-titleH1":"_0_9_0_text__preset-titleH1___11fnX","preset-titleH2":"_0_9_0_text__preset-titleH2___1wSXB","preset-titleH3":"_0_9_0_text__preset-titleH3___3TtB3","preset-titleH4":"_0_9_0_text__preset-titleH4___3Te_d","preset-textXLarge":"_0_9_0_text__preset-textXLarge___2TR0V","preset-textLarge":"_0_9_0_text__preset-textLarge___2wPhu","preset-textMain":"_0_9_0_text__preset-textMain___DBI8G","preset-textSmall":"_0_9_0_text__preset-textSmall___1HwlN","wrap-normal":"_0_9_0_text__wrap-normal___19vDF","wrap-anywhere":"_0_9_0_text__wrap-anywhere___szDWN","wrap-break-word":"_0_9_0_text__wrap-break-word___pQEvA","bold":"_0_9_0_text__bold___jzg6B","linethrough":"_0_9_0_text__linethrough___1sBnL","color-primaryWhite":"_0_9_0_text__color-primaryWhite___29d0c","color-primaryBlack":"_0_9_0_text__color-primaryBlack___2dBcH","color-secondaryLight":"_0_9_0_text__color-secondaryLight___KzOih","color-secondaryMedium":"_0_9_0_text__color-secondaryMedium___2Qr4x","color-secondaryDark":"_0_9_0_text__color-secondaryDark___3f5Qy","color-tertiaryLight":"_0_9_0_text__color-tertiaryLight___3CbcO","color-tertiaryMain":"_0_9_0_text__color-tertiaryMain___590O8","color-accentBronze":"_0_9_0_text__color-accentBronze___28DBE","color-accentDark":"_0_9_0_text__color-accentDark___33_O2","color-successLightest":"_0_9_0_text__color-successLightest___1UPZg","color-successMedium":"_0_9_0_text__color-successMedium___XdOZa","color-error":"_0_9_0_text__color-error___2JsTC"};

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = require("xss");

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_0_9_0_DomainCut__container___3NamJ","name":"_0_9_0_DomainCut__name___3NUEb","zone":"_0_9_0_DomainCut__zone___18HcN"};

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = require("classnames");

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "Text", function() { return /* reexport */ Text; });
__webpack_require__.d(__webpack_exports__, "DomainOutput", function() { return /* reexport */ DomainOutput; });
__webpack_require__.d(__webpack_exports__, "EWrapType", function() { return /* reexport */ EWrapType; });
__webpack_require__.d(__webpack_exports__, "ETextPresets", function() { return /* reexport */ ETextPresets; });
__webpack_require__.d(__webpack_exports__, "ETextColors", function() { return /* reexport */ ETextColors; });
__webpack_require__.d(__webpack_exports__, "ETextTags", function() { return /* reexport */ ETextTags; });
__webpack_require__.d(__webpack_exports__, "ETextWraps", function() { return /* reexport */ ETextWraps; });

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(0);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// EXTERNAL MODULE: external "classnames"
var external_classnames_ = __webpack_require__(5);
var external_classnames_default = /*#__PURE__*/__webpack_require__.n(external_classnames_);

// CONCATENATED MODULE: ./src/types.ts
var ETextPresets;
(function (ETextPresets) {
    ETextPresets["displayL"] = "displayL";
    ETextPresets["displayS"] = "displayS";
    ETextPresets["titleH1"] = "titleH1";
    ETextPresets["titleH2"] = "titleH2";
    ETextPresets["titleH3"] = "titleH3";
    ETextPresets["titleH4"] = "titleH4";
    ETextPresets["textXLarge"] = "textXLarge";
    ETextPresets["textLarge"] = "textLarge";
    ETextPresets["textMain"] = "textMain";
    ETextPresets["textSmall"] = "textSmall";
})(ETextPresets || (ETextPresets = {}));
var ETextColors;
(function (ETextColors) {
    ETextColors["primaryWhite"] = "primaryWhite";
    ETextColors["primaryBlack"] = "primaryBlack";
    ETextColors["secondaryLight"] = "secondaryLight";
    ETextColors["secondaryMedium"] = "secondaryMedium";
    ETextColors["secondaryDark"] = "secondaryDark";
    ETextColors["tertiaryLight"] = "tertiaryLight";
    ETextColors["tertiaryMain"] = "tertiaryMain";
    ETextColors["accentBronze"] = "accentBronze";
    ETextColors["accentDark"] = "accentDark";
    ETextColors["successLightest"] = "successLightest";
    ETextColors["successMedium"] = "successMedium";
    ETextColors["error"] = "error";
})(ETextColors || (ETextColors = {}));
var ETextTags;
(function (ETextTags) {
    ETextTags["h1"] = "h1";
    ETextTags["h2"] = "h2";
    ETextTags["h3"] = "h3";
    ETextTags["h4"] = "h4";
    ETextTags["h5"] = "h5";
    ETextTags["h6"] = "h6";
    ETextTags["p"] = "p";
    ETextTags["span"] = "span";
})(ETextTags || (ETextTags = {}));
var ETextWraps;
(function (ETextWraps) {
    ETextWraps["normal"] = "normal";
    ETextWraps["anywhere"] = "anywhere";
    ETextWraps["break-word"] = "break-word";
})(ETextWraps || (ETextWraps = {}));

// EXTERNAL MODULE: external "tslib"
var external_tslib_ = __webpack_require__(1);

// EXTERNAL MODULE: external "xss"
var external_xss_ = __webpack_require__(3);

// CONCATENATED MODULE: ./src/sanitize.ts


var DEFAULT_OPTIONS = {
    whiteList: Object(external_tslib_["__assign"])(Object(external_tslib_["__assign"])({}, Object(external_xss_["getDefaultWhiteList"])()), { svg: [] }),
    onTagAttr: function (tag, name, value, isWhiteAttr) {
        if (name === 'style') {
            return name + "=\"" + Object(external_xss_["escapeAttrValue"])(value) + "\"";
        }
        if (!isWhiteAttr) {
            return '';
        }
        return name + "=\"" + Object(external_xss_["safeAttrValue"])(tag, name, value, external_xss_["cssFilter"]) + "\"";
    },
    stripIgnoreTag: true,
    stripIgnoreTagBody: ['script'],
};
var sanitize = function (unsanitizedString, options) {
    if (options === null || options === void 0 ? void 0 : options.disabledSanitize) {
        return unsanitizedString;
    }
    return Object(external_xss_["filterXSS"])(unsanitizedString, options !== null && options !== void 0 ? options : DEFAULT_OPTIONS);
};

// EXTERNAL MODULE: ./src/styles/text.scss
var styles_text = __webpack_require__(2);
var text_default = /*#__PURE__*/__webpack_require__.n(styles_text);

// CONCATENATED MODULE: ./src/Text.tsx





var tagMap = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    p: 'p',
    span: 'span',
};
var Text = Object(external_react_["forwardRef"])(function (_a, ref) {
    var _b, _c;
    var _d = _a.preset, preset = _d === void 0 ? ETextPresets.textMain : _d, _e = _a.color, color = _e === void 0 ? ETextColors.primaryBlack : _e, _f = _a.isBold, isBold = _f === void 0 ? false : _f, _g = _a.tag, tag = _g === void 0 ? ETextTags.span : _g, _h = _a.wrap, wrap = _h === void 0 ? ETextWraps.normal : _h, html = _a.html, _j = _a.linethrough, linethrough = _j === void 0 ? false : _j, sanitizeOptions = _a.sanitizeOptions, _k = _a.className, className = _k === void 0 ? '' : _k, children = _a.children;
    var textClassNames = external_classnames_default()(text_default.a.base, text_default.a["preset-" + preset], text_default.a["color-" + color], text_default.a["wrap-" + wrap], (_b = {}, _b[text_default.a.bold] = isBold, _b), (_c = {}, _c[text_default.a.linethrough] = linethrough, _c), className);
    var Tag = tagMap[tag];
    if (html && typeof children === 'string') {
        var cleanText = sanitize(children, sanitizeOptions);
        return (
        // eslint-disable-next-line react/no-danger
        external_react_default.a.createElement(Tag, { ref: ref, className: textClassNames, dangerouslySetInnerHTML: { __html: cleanText } }));
    }
    return external_react_default.a.createElement(Tag, { ref: ref, className: textClassNames }, children);
});
Text.displayName = 'Text';

// CONCATENATED MODULE: ./src/DomainOutput/components/DomainWrap.tsx


var WRAP_TYPE = 'break-word';
var DomainWrap = function (_a) {
    var name = _a.name, zone = _a.zone, preset = _a.preset, color = _a.color, zonePreset = _a.zonePreset, zoneColor = _a.zoneColor;
    return (external_react_default.a.createElement("div", null,
        external_react_default.a.createElement(Text, { preset: preset, color: color, wrap: WRAP_TYPE }, name),
        zone && (external_react_default.a.createElement(Text, { preset: zonePreset || preset, color: zoneColor || color, wrap: WRAP_TYPE }, "." + zone))));
};

// EXTERNAL MODULE: ./src/DomainOutput/components/DomainCut.scss
var DomainCut = __webpack_require__(4);
var DomainCut_default = /*#__PURE__*/__webpack_require__.n(DomainCut);

// CONCATENATED MODULE: ./src/DomainOutput/components/DomainCut.tsx




var DomainCut_DomainCut = function (_a) {
    var name = _a.name, zone = _a.zone, showTooltip = _a.showTooltip, zonePreset = _a.zonePreset, zoneColor = _a.zoneColor, textProps = Object(external_tslib_["__rest"])(_a, ["name", "zone", "showTooltip", "zonePreset", "zoneColor"]);
    return (external_react_default.a.createElement("span", { className: DomainCut_default.a.container },
        external_react_default.a.createElement("span", { className: DomainCut_default.a.name, title: showTooltip ? name + "." + zone : '' },
            external_react_default.a.createElement(Text, Object(external_tslib_["__assign"])({}, textProps), name)),
        zone && (external_react_default.a.createElement("span", { className: DomainCut_default.a.zone },
            external_react_default.a.createElement(Text, { preset: zonePreset || textProps.preset, color: zoneColor || textProps.color }, "." + zone)))));
};

// CONCATENATED MODULE: ./src/DomainOutput/types.ts
var EWrapType;
(function (EWrapType) {
    EWrapType["cut"] = "cut";
    EWrapType["wrap"] = "wrap";
})(EWrapType || (EWrapType = {}));

// CONCATENATED MODULE: ./src/DomainOutput/utils.ts

function splitDomainToNameZone(domain) {
    var _a = Object(external_tslib_["__read"])(domain.split('.')), name = _a[0], zones = _a.slice(1);
    return { name: name, zone: zones.join('.') };
}

// CONCATENATED MODULE: ./src/DomainOutput/DomainOutput.tsx






var DomainOutput = function (_a) {
    var value = _a.value, _b = _a.showTooltip, showTooltip = _b === void 0 ? false : _b, _c = _a.wrapType, wrapType = _c === void 0 ? EWrapType.cut : _c, zonePreset = _a.zonePreset, zoneColor = _a.zoneColor, textProps = Object(external_tslib_["__rest"])(_a, ["value", "showTooltip", "wrapType", "zonePreset", "zoneColor"]);
    var _d = splitDomainToNameZone(value), name = _d.name, zone = _d.zone;
    var isCut = wrapType === EWrapType.cut;
    return (isCut ? (external_react_default.a.createElement(DomainCut_DomainCut, Object(external_tslib_["__assign"])({ name: name, zone: zone, showTooltip: showTooltip, zonePreset: zonePreset, zoneColor: zoneColor }, textProps))) : (external_react_default.a.createElement(DomainWrap, Object(external_tslib_["__assign"])({ name: name, zone: zone, zonePreset: zonePreset, zoneColor: zoneColor }, textProps))));
};

// CONCATENATED MODULE: ./src/DomainOutput/index.ts



// CONCATENATED MODULE: ./src/index.ts




// CONCATENATED MODULE: ./index.ts



/***/ })
/******/ ]);